var _effectorFileName = "/src/page-content/for-companies/components/pluses-work-with-us/pluses-work-with-us.tsx";
import Link from 'next/link';
import { Article } from '@/shared/components/article';
import DownloadIcon from '@/shared/components/icons/download-icon';
import { TextPlusesList } from '@/shared/components/text-pluses-list';
import { Button } from '@/shared/components/ui/button';
import { Card } from '@/shared/components/ui/card';
import { cn } from '@/shared/lib/cn';
import { APP_TITLE } from '@/shared/lib/seo/meta';
import { FOR_COMPANIES_PLUSES_LIST } from '../constants/pluses-list';
export const PlusesWorkWithUs = () => {
  return <Article>
      <h2 className="mb-4 header-h2 sm:mb-8">Преимущества</h2>

      <section className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[1fr,minmax(200px,30%)] xl:grid-cols-[1fr,minmax(200px,40%)]">
        <TextPlusesList items={FOR_COMPANIES_PLUSES_LIST} />

        <Card className={cn('group relative mx-auto max-w-96 overflow-hidden rounded-xl px-4 py-6 md:gap-x-8',
      // light styles
      'bg-white [box-shadow:0_0_0_1px_rgba(0,0,0,.03),0_2px_4px_rgba(0,0,0,.05),0_12px_24px_rgba(0,0,0,.05)]',
      // dark styles
      'transform-gpu dark:bg-black dark:[border:1px_solid_rgba(255,255,255,.1)] dark:[box-shadow:0_-20px_80px_-20px_#ffffff1f_inset]')}>
          <div className="flex-1 space-y-1">
            <h3 className="mb-3 header-h3 sm:mb-6">В&nbsp;коммерческом предложении мы&nbsp;все подробно описали</h3>

            <div className="flex justify-center lg:block">
              <Link href="/files/enlerno-business-proposal_v2.pdf" rel="noopener noreferrer" target="_blank" download={`${APP_TITLE} - Коммерческое предложение`} aria-label="Ознакомиться с коммерческим предложением">
                <Button className="space-x-2" type="button" aria-label="Ознакомиться с коммерческим предложением">
                  <span>Ознакомиться</span>

                  <DownloadIcon className="h-5 w-5 text-brand-accent-normal dark:text-brand-accent-light" />
                </Button>
              </Link>
            </div>
          </div>
        </Card>
      </section>
    </Article>;
};